<template>
    <b-card header-tag="header"
            header-class="text-center"
            header-bg-variant="primary"
            class="mb-3">
        <ul class="list-unstyled">
            <li v-for="list in exportTasks" :key="list.id">
                <section class="pdf-item">
                <b-row class="mb-2">
                    <b-col cols="4">
                        <label style="font-weight: bold" class="task-list-name">{{$t('tasks.taskgroup')}}: {{ list.name }} ({{ list.tasks.length }})</label>
                    </b-col>
                    <b-col cols="2">
                        <label style="font-weight: bold" class="task-list-name">{{$t('tasks.modified')}}</label>
                    </b-col>
                    <b-col cols="2">
                        <label style="font-weight: bold" class="task-list-name">{{$t('tasks.assignedTo')}}</label>
                    </b-col>
                    <b-col cols="2">
                        <label style="font-weight: bold" class="task-list-name">{{$t('tasks.completed')}}</label>
                    </b-col>
                    <b-col cols="2">
                        <label style="font-weight: bold" class="task-list-name">{{$t('tasks.due')}}</label>
                    </b-col>
                </b-row>
                </section>
                <ul class="pl-3">
                    <section class="pdf-item">
                        <li v-for="task in list.tasks" :key="task.id">
                            <b-row class="mb-2">
                                <b-col cols="4">
                                    <span>{{ task.subject }}</span>
                                </b-col>
                                <b-col cols="2">
                                    <span>{{ task.modified | formatDateTime }}</span>
                                </b-col>
                                <b-col cols="2">
                                    <span v-show="task.assignedTo">{{ assignedProjectMember(task.assignedTo) }}</span>
                                </b-col>
                                <b-col cols="2">
                                    <span v-show="task.complete">{{ $t('tasks.completed') }}</span>
                                </b-col>
                                <b-col cols="2">
                                    <span>{{ taskDue(task) }}</span>
                                </b-col>
                            </b-row>
                        </li>
                    </section>
                </ul>
                <hr>
            </li>
        </ul>
    </b-card>
</template>

<script>
    import { mapFilters } from '@/filters/mapFilters';
    import Header from "../../Header";
    import {mapGetters} from "vuex";

    export default {
        name: 'export-project-tasks',
        components: {Header},
        props: ['exportTasks'],

        computed: {
            ...mapGetters({
                projectCollaborators: 'projects/projectCollaborators'
            }),
            project() {
                return this.$store.state.projects.currentProject;
            }
        },
        methods: {
            ...mapFilters(['formatDate']),
            assignedProjectMember(assignedTo) {
                return this.getProjectMember(assignedTo).displayName || assignedTo;
            },
            taskDue(task) {
                if (!task.due) {
                    return this.$t('tasks.dueNotSet');
                } else {
                    return this.$t('tasks.due') + ' ' + this.formatDate(task.due);
                }
            },
            getProjectMember(assignedTo) {
                return this.projectCollaborators.find(m => m.id === assignedTo) || {};
            },
        },
        created() {
        }
    }
</script>

<style lang="scss" scoped>
    .task-list-name {
        display: inline-block;
        margin-bottom: 10px;
    }
</style>
